import type { ModuleDefinition } from "../types";
import { GUESTS_READ } from "./permissions";

const screens = () => import("./screens");

export const guestsModule: ModuleDefinition = {
  id: "guests",
  labelKey: "module.guests",
  nav: [
    { id: "arrivals", labelKey: "guests.nav.arrivals", to: "/guests", icon: "flag", permission: GUESTS_READ, end: true },
    { id: "calendar", labelKey: "guests.nav.calendar", to: "/guests/calendar", icon: "calendar", permission: GUESTS_READ },
    { id: "visits", labelKey: "guests.nav.visits", to: "/guests/visits", icon: "log", permission: GUESTS_READ },
    { id: "people", labelKey: "guests.nav.people", to: "/guests/people", icon: "users", permission: GUESTS_READ },
    { id: "policy", labelKey: "guests.nav.policy", to: "/guests/policy", icon: "sliders", permission: GUESTS_READ },
  ],
  routes: [
    { path: "guests", permission: GUESTS_READ, load: async () => ({ default: (await screens()).ArrivalsPage }) },
    // The calendar library is in its own chunk, fetched only here (after the module's shared screens, translations and styles).
    { path: "guests/calendar", permission: GUESTS_READ, load: async () => { await screens(); return import("./screens/CalendarPage"); } },
    { path: "guests/visits", permission: GUESTS_READ, load: async () => ({ default: (await screens()).VisitsPage }) },
    { path: "guests/people", permission: GUESTS_READ, load: async () => ({ default: (await screens()).GuestsPage }) },
    { path: "guests/people/:guestId", permission: GUESTS_READ, load: async () => ({ default: (await screens()).GuestPage }) },
    { path: "guests/members/:memberId", permission: GUESTS_READ, load: async () => ({ default: (await screens()).MemberGuestsPage }) },
    { path: "guests/policy", permission: GUESTS_READ, load: async () => ({ default: (await screens()).PolicyPage }) },
  ],
};
